import jwtService from "@/core/services/jwt.service";

function getLogins(){
    return JSON.parse(localStorage.getItem('logins') ?? "[]")
}


function addLogin(name , token){
    let logins = getLogins();
    logins.push({
        name,
        token
    })
    localStorage.setItem('logins', JSON.stringify(logins))
}

function changeLogin(index){
    let logins = getLogins()
    localStorage.setItem('logins', JSON.stringify(logins.slice(0,index)))
    jwtService.saveToken(logins[index].token)
}



export default {
    getLogins,
    addLogin,
    changeLogin
}
